<template>
  <div class="tip-box" >
    <img src="../assets/images/contribution.png" @click="linkTo('/contribution')" alt="">
    <img src="../assets/images/contribution1.png" @click="linkTo('/member/person/register')" alt="">
    <img src="../assets/images/contribution2.png" @click="linkTo('/member/group/register')" alt="">
    <img src="../assets/images/contribution3.png" @click="linkTo('/aboutus')" alt="">
  </div>
</template>

<script>
import router from '@/router';
export default {
  data() {
    return {}
  },
  methods: {
    linkTo(uri) {
      router.push(uri+'?skipBottom=1');
    }
  }
}
</script>

<style lang="less" scoped>
.tip-box {
  position: fixed;
  right: 0px;
  bottom: 300px;

  > img {
    width: 80px;
    cursor: pointer;
    display: block;
    margin-top:2px;
  }
}
</style>